export const SOURCE_ACTIVITIES_NAME = "source-activities";
export const LAYER_ACTIVITIES_POINTS_NAME = "layer-activities-points";